export const getGrade = (mark) => {
  mark = parseFloat(mark);

  if (mark >= 90.5) {
    return "A++";
  } else if (mark >= 80.5) {
    return "A+";
  } else if (mark >= 70.5) {
    return "A";
  } else if (mark >= 60.5) {
    return "A-";
  } else if (mark >= 50.5) {
    return "B";
  } else {
    return "C";
  }
};
